<div class="statut"
     [style.color]="couleurStatut()"
     [style.--statut-color]="couleurStatut()">
	<strong>{{ cleTraductionStatut() | translate }}</strong>
</div>